import operate from './operate'
export default function () {
  return [
    {
      width: 50,
      [$field]: 'xuhao',
      render: (h, row) => {
        return h('span', Number(row.index) + 1)
      }
    },
    {
      isEdit: true,
      [$field]: 'content',
      render: (h, { row }) => {
        if (row.content == '无意见') {
          return h('Input', {
            props: {
              value: row.content,
              disabled: true
            }
          })
        } else if (row.content && this.type == 'see') {
          return h('Input', {
            props: {
              value: row.content,
              disabled: true
            }
          })
        } else {
          return h('Input', {
            props: {
              value: row.content
            },
            on: {
              'on-change': (event) => {
                this.$set(this.opinions[row.$index].feedback[row._index], 'content', event.target.value)
              }
            }
          })
        }
      }
    },
    {
      [$field]: 'operate',
      width: 200,
      isOperate: true,
      slotComponent: operate
    }
  ]
}